import React from 'react';
import styled from 'styled-components';
import theme from '../styles/theme';

const FOOTER_HEIGHT = '84px';

const FooterContainer = styled.footer`
  width: 100%;
  background: ${theme.colors.background.secondary};
  color: ${theme.colors.text.muted};
  min-height: ${FOOTER_HEIGHT};
  padding: 0;
  display: flex;
  align-items: center;
  box-shadow: inset 0 1px 0 ${theme.colors.border.primary};
`;

const FooterInner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 ${theme.spacing[6]};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${theme.spacing[4]};
  flex-wrap: wrap;
  min-height: ${FOOTER_HEIGHT};

  @media (max-width: ${theme.breakpoints.md}) {
    flex-direction: column;
    text-align: center;
  }
`;

const FooterBrand = styled.a`
  font-weight: 500;
  color: ${theme.colors.text.secondary};
  text-decoration: none;

  &:hover,
  &:focus {
    color: ${theme.colors.text.primary};
  }
`;

const FooterInfo = styled.span`
  display: flex;
  align-items: center;
  gap: ${theme.spacing[3]};
`;

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <FooterContainer>
      <FooterInner>
        <FooterBrand
          href="https://haevo.com.br/"
          target="_blank"
          rel="noopener noreferrer"
        >
          © {currentYear} Haevo Revenda
        </FooterBrand>
        <FooterInfo>Todos os direitos reservados.</FooterInfo>
      </FooterInner>
    </FooterContainer>
  );
};

export default Footer;


